import { fetchWrapper } from "../utils/fetch-wrapper";

const fichiersService = {
  getAll,
  getById,
  post,
  update,
  uploadfiles,
  deletefiles,
  getgexbox,
  correspondanceFichier,
  validationFichiers,
  validationFichier,
  encoursFichier,
  atraiterFichier,
  delete: _delete,
  DesassocierFichier,
  renommerFichier,
};

function getAll() {
  return fetchWrapper.get("fichiers/");
}
function getgexbox(
  env_client_id: any = "",
  status_fichier: any = "",
  user_id: any = ""
) {
  const queryParams: Record<string, any> = {};

  if (env_client_id !== "") {
    queryParams.env_client_id = env_client_id;
  }
  if (status_fichier !== "") {
    queryParams.status_fichier = status_fichier;
  }

  if (user_id !== "") {
    queryParams.user_id = user_id;
  }

  const queryString = Object.keys(queryParams)
    .map((key) => `${key}=${queryParams[key]}`)
    .join("&");

  return fetchWrapper.get(`fichiers/gexbox?${queryString}`);
}
function getById(id) {
  return fetchWrapper.get(`fichiers/${id}`);
}

function correspondanceFichier(data) {
  return fetchWrapper.post(`fichiers/correspondance`, data);
}

function DesassocierFichier(data) {
  return fetchWrapper.post(`fichiers/desassocier`, data);
}

function post(data) {
  return fetchWrapper.post("fichiers/", data);
}

function validationFichiers(data) {
  return fetchWrapper.put("fichiers/validation", data);
}

function validationFichier(id, params) {
  return fetchWrapper.post(`fichiers/verification/${id}`, params);
}
function encoursFichier(id, params) {
  return fetchWrapper.post(`fichiers/en_cours/${id}`, params);
}

function update(id, params) {
  return fetchWrapper.put(`fichiers/${id}`, params);
}

function _delete(id) {
  return fetchWrapper.delete(`fichiers/${id}`);
}

function uploadfiles(formdata, id, env_client_id: any = "") {
  const queryParams: Record<string, any> = {};

  if (env_client_id !== "") {
    queryParams.env_client_id = env_client_id;
  }

  const queryString = Object.keys(queryParams)
    .map((key) => `${key}=${queryParams[key]}`)
    .join("&");

  return fetchWrapper.post_formdata(
    `fichiers/import/${id}?${queryString}`,
    formdata
  );
}

function atraiterFichier(id, params) {
  return fetchWrapper.post(`fichiers/a_traiter/${id}`, params);
}

function deletefiles(file_ids) {
  return fetchWrapper.put("fichiers/delete/files", file_ids);
}

function renommerFichier(data) {
  return fetchWrapper.put("fichiers/rename", data);
}

export default fichiersService;
